import React from "react";
import { profils } from "../data/profils";
import { getProfilIdFromUrlName } from "../utils/chatProfileUtils";

const Header = () => {
  const profilId = getProfilIdFromUrlName();
  const profil = profils[profilId] || profils[1];

  return (
    <header className="bg-gradient-to-r from-red-900 via-rose-900 to-pink-900 py-4 px-4 shadow-lg">
      <div className="container mx-auto flex justify-between items-center">
        {/* Logo et titre */}
        <div className="flex items-center space-x-3">
          <span className="text-3xl md:text-4xl animate-pulse">💋</span>
          <h1 className="text-white font-extrabold text-2xl md:text-3xl tracking-tight font-serif drop-shadow-lg">
            VoirPhotos
          </h1>
        </div>
        {/* Nom du profil à droite avec dot vert */}
        <div className="flex items-center space-x-2">
          <span className="relative flex items-center">
            <span className="text-white text-lg md:text-xl font-semibold bg-rose-900 bg-opacity-60 px-4 py-2 rounded-full shadow">
              {profil.name}
            </span>
            <span className="absolute -right-2 top-1/2 transform -translate-y-1/2 w-3 h-3 bg-green-500 border-2 border-white rounded-full shadow animate-pulse "></span>
          </span>
        </div>
      </div>
    </header>
  );
};

export default Header;
